document.addEventListener('turbolinks:load', function () {
    const assignment_library_content = document.getElementById("assignment_resource");

    if (assignment_library_content == null) {
        return
    }

    window.initializeWidgetsAndSort = () => {
        selected_assignments_widget();
        initializeSort();
        window.initializeAssignmentResourceFolders?.();
    }

    window.queryLoadingCardElements = (resourceGroupId) => {
        const $container = $("#" + resourceGroupId + "_loading");
        return {
            container: $container,
            progressBar: $container.find(".assignment_resource__main_panel__form__resources__card__progress-bar"),
            status: $container.find(".assignment_resource__main_panel__form__resources__card__primary-information-description-activity_list"),
            progressRegion: $container.find('.assignment_resource__main_panel__form__resources__card__progress[role="progressbar"]')
        };
    }

    function updateProgress(elements, percent, totalJobs, remainingJobs) {
        const safePercent = Math.max(0, Math.min(100, Number(percent) || 0));
        const totalIsNum = Number.isFinite(totalJobs) && totalJobs > 0;
        const remainingIsNum = Number.isFinite(remainingJobs);
        const noJobsRemaining = remainingIsNum && remainingJobs <= 0;

        // Progress bar width
        elements.progressBar.css("width", safePercent + "%");

        // ARIA updates (optional but good for a11y)
        if (elements.progressRegion.length) {
            elements.progressRegion
                .attr("aria-valuenow", safePercent)
                .attr("aria-valuemin", 0)
                .attr("aria-valuemax", 100)
                .attr("aria-valuetext", (noJobsRemaining ? "Finishing up… " : "Copying assignments… ") + safePercent + "%");
        }

        let text;
        if (noJobsRemaining) {
            if (totalIsNum) {
                const jobsDone = Math.max(0, totalJobs - 0);
                text = `Finishing up… ${safePercent}% (${jobsDone}/${totalJobs})`;
            } else {
                text = `Finishing up… ${safePercent}%`;
            }
        } else if (totalIsNum && remainingIsNum) {
            const jobsDone = Math.max(0, totalJobs - remainingJobs);
            text = `Copying assignments… ${safePercent}% (${jobsDone}/${totalJobs})`;
        } else {
            text = `Copying assignments… ${safePercent}%`;
        }

        elements.status.text(text);
    }

    window.startProgressPolling = (resourceGroupId, elements, search_word) => {
        const pollingIntervalMs = 500;
        const pollingTimerId = setInterval(function () {
            if (!elements.container.length) {
                clearInterval(pollingTimerId);
                return;
            }
            const total = parseInt(elements.container.data("total-sync-jobs"), 10);

            $.ajax({
                url: "/assignment_resource_groups/" + encodeURIComponent(resourceGroupId) + "/render_card",
                method: "GET",
                headers: {"Accept": "text/html, application/json"},
                data: { premade: false, initial_total: total, search_word: search_word }
            })
                .always((response) => handleResponse(response, pollingTimerId, elements));

        }, pollingIntervalMs);
    }

    function handleResponse(response, pollingTimerId, elements) {
        if (response.status === "copying") {
            updateProgress(elements, response.progress, response.total, response.remaining);
            return;
        }
        if (response.status === "succeeded") {
            clearInterval(pollingTimerId);
            if (!elements.container.length) return;
            updateProgress(elements, 100, response.total, 0);
            setTimeout(function () {
                if (elements.container.length) {
                    elements.container.replaceWith(response.html);
                    initializeWidgetsAndSort()
                    count_search_results()
                    $('[data-bs-toggle="tooltip"]').tooltip();
                }
            }, 750);
        }

        if (response.status === "failed") {
            clearInterval(pollingTimerId);
            if (elements.container.length) {
                elements.container.replaceWith(response.html);
                initializeWidgetsAndSort()
                $('[data-bs-toggle="tooltip"]').tooltip();
            }
        }

        return response.status
    }
})
